<div class="card rounded">
  <div *ngIf="!allowEditing">
    <div *ngIf="member$ | async as member" class="d-flex flex-column gap-3">
      <div class="">
        <label class="mb-0 font-size-12 personal-info">{{ 'account.details.dob' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 mt-1 rounded d-flex flex-row align-items-center">
          <span class="icon material-icons" aria-hidden="true">date_range</span>
          <span class="ms-3 font-size-12">{{ member.DOB | date : 'MMM dd, yyyy' }}</span>
        </div>
      </div>
      <div>
        <label class="mb-0 font-size-12 personal-info">{{ 'account.details.contact.no' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 mt-1 rounded d-flex flex-row align-items-center">
          <span class="icon material-icons" aria-hidden="true">call</span>
          <span class="ms-3 font-size-12">{{ member.MobileNumber }}</span>
        </div>
      </div>
      <div>
        <label class="mb-0 font-size-12 personal-info">{{ 'account.details.email' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 mt-1 rounded d-flex flex-row align-items-center">
          <span class="icon material-icons" aria-hidden="true">email</span>
          <span class="ms-3 font-size-12">{{ member.EmailAddress1 }}</span>
        </div>
      </div>
      <div>
        <label class="mb-0 font-size-12 personal-info">{{ 'account.details.home.address' | translate }}</label>
        <div class="d-flex bg-muted p-2 m-0 mt-1 rounded d-flex flex-row align-items-start">
          <span class="location-icon material-icons" aria-hidden="true">location_on</span>
          <span class="ms-2 font-size-12 d-inline-block">
            <div>{{ member.AddressName }},</div>
            <div>{{ member.Street }}</div>
            <div>{{ member.Town }}</div>
            <div>{{ member.Country }}</div>
            <div>{{ member.PostCode }}</div>
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="allowEditing">
      <fgb-edit-account-details></fgb-edit-account-details>
    </div>
  </div>
  <ng-template #loadingRef>
    <fgb-loading></fgb-loading>
  </ng-template>
</div>
